export interface OfferAdvertiserUrlParam {
    macros: string;
    description: string;
}

export const OfferAdvertiserUrlParams: OfferAdvertiserUrlParam[] = [
    {
        macros: "{clickid} or {click_id}",
        description: "Click ID",
    },
    {
        macros: "{pid}",
        description: "Partner ID",
    },
    {
        macros: "{offer_id}",
        description: "Offer ID",
    },
    {
        macros: "{offer_name}",
        description: "Offer title",
    },
];
